"use client";

import React from "react";
import Button from "@/components/ui/Button";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CarouselFirstProps } from "../types";
import { useCarouselStore } from "./carousel-provider";

function CarouselFirst({
  variant = "outline",
  size = "icon",
  icon = "chevron-first",
  "aria-label": ariaLabel = "First slide",
  className,
  ...props
}: CarouselFirstProps) {
  const canScrollFirst = useCarouselStore(state => state.canScrollFirst);
  const scrollFirst = useCarouselStore(state => state.scrollFirst);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const handleOnClick = React.useCallback(() => {
    scrollFirst();
  }, [scrollFirst]);

  return (
    <Button.Icon
      variant={variant}
      size={size}
      icon={icon}
      data-slot="carousel-first"
      disabled={!canScrollFirst}
      onClick={handleOnClick}
      className={cn(className, classes)}
      aria-label={ariaLabel}
      {...native}
    />
  );
}

export default CarouselFirst;
